import http from '@/api/http';

/** 组合接口 --- 执业、从业区分 **/
// 企业中心执业受理
export const practiceAccept = (params, code) => {
  let url = '/ks/practice/ent/v1/practice-accept'; // 企业执业受理--- 管理员
  if (code == 'cysq') {
    url = '/ks/practice/per/v1/practice-accept'; // 人员执业受理--- 管理员
  }
  return http.post(url, params);
};
// 企业中心执业详情
export const practiceDetail = (params, code) => {
  let url = '/ks/practice/ent/v1/practice-detail'; // 企业执业详情接口 --- 管理员/用户
  if (code == 'cysq') {
    url = '/ks/practice/per/v1/practice-detail'; // 人员从业详情接口 --- 管理员
  }
  return http.post(url, params);
};

/** 组合接口 --- 企业、人员区分 **/
// 企业、人员 普通详情信息接口
export const getDetailInfo = (params, code) => {
  let url = '/ks/basic/v1/enterprise/detail'; // 企业信息详情
  if (code == 'qyry') {
    url = '/ks/basic/v1/personnel/detail'; // 人员信息详情
  }
  return http.post(url, params);
};
// 企业、人员 普通详情保存更新
export const updateDetailInfo = (params, code) => {
  let url = '/ks/basic/v1/enterprise/update'; // 企业信息详情保存---用户
  if (code == 'qyry') {
    url = '/ks/basic/v1/personnel-save'; // 人员信息详情保存 --- 管理员/用户
  }
  return http.post(url, params);
};
// 企业、人员提交
export const infoSubmit = (params, code) => {
  let url = '/ks/basic/v1/enterprise/submit'; // 提交企业信息 --- 用户
  if (code == 'qyry') {
    url = '/ks/basic/v1/personnel/submit'; // 提交人员信息 --- 用户
  }
  return http.post(url, params);
};
// 企业、人员撤回
export const infoRevoke = (params, code) => {
  let url = '/ks/basic/v1/enterprise/revoke'; //  撤回企业信息 --- 用户
  if (code == 'qyry') {
    url = '/ks/basic/v1/personnel/revoke'; // 撤回人员信息 --- 用户
  }
  return http.post(url, params);
};
// 企业、人员受理
export const infoAudit = (params, code) => {
  let url = '/ks/basic/v1/enterprise/audit'; //  受理企业信息 --- 管理员
  if (code == 'qyry') {
    url = '/ks/basic/v1/personnel/audit'; // 受理人员信息 -- 管理员
  }
  return http.post(url, params);
};
// 企业、人员 数据、业绩统计 -- 饼图(人员信息中该接口尚未确定)
export const infoStatistics = (params, type) => {
  let url = '/ks/distribution/v1/enterprise/statistics';
  if (type === 'qyry') return;
  // url = '/ks/enterprise/v1/cert-list';
  return http.post(url, params);
};
// 企业、人员 数据、业绩统计--列表 (人员信息中该接口尚未确定)
export const infoProjectsList = (params, type) => {
  let url = '/ks/distribution/v1/enterprise/projects';
  if (type === 'qyry') return;
  // url = '/ks/enterprise/v1/cert-list';
  return http.post(url, params);
};

// 人员证书列表
export const getCertList = (params, certBm) => {
  let url = '/ks/basic/v1/personnel/certificates'; //  人员 --- 管理员
  if (certBm) {
    url = '/ks/basic/v1/enterprise/qualifications'; // 企业 -- 管理员
  }
  return http.post(url, params);
};


// 人员证书列表
export const getCertificateList = (params) => {
  return http.post('/ks/basic/v1/cert/list', params);
};

// 提交记录
export const submitRecord = (params, code) => {
  let url = '/ks/basic/v1/enterprise/audit'; //  受理企业信息 --- 管理员
  if (code == 'qyry') {
    url = '/ks/basic/v1/personnel/audit'; // 受理人员信息 -- 管理员
  }
  return http.post(url, params);
};

// 共享审核
export const auditShare = (params, type) => {
  let url = '/ks/practice/ent/v1/audit-cancel'; //  审核企业 --- 管理员
  if (type == 'per') {
    url = '/ks/practice/per/v1/audit-cancel'; // 审核人员 -- 管理员
  }
  return http.post(url, params);
};

// 取消共享
export const cancelShare = (params, type) => {
  let url = '/ks/practice/ent/v1/practice-cancel'; //  取消企业 --- 管理员
  if (type == 'cysq') {
    url = '/ks/practice/per/v1/practice-cancel'; // 取消人员 -- 管理员
  }
  return http.post(url, params);
};

/** 企业信息 **/
// 企业信息列表 --- 管理员
export const getCompanyList = (params) => {
  return http.post('/ks/basic/v1/enterprise/ent-list', params);
};
// 企业执业地信息 --- 管理员
export const practiceInfo = (params) => {
  return http.post('/ks/practice/ent/v1/practice-info', params);
};
// 企业执业区域 --- 用户
export const entPracticeArea = (params) => {
  return http.post(`/ks/practice/ent/v1/practice-area`, params);
};
// 企业申请执业 --- 用户
export const entPracticeApply = (params) => {
  return http.post(`/ks/practice/ent/v1/practice-apply`, params);
};

/** 人员信息 **/
// 人员信息列表 -- 管理员
export const perPracticeList = (params) => {
  return http.post(`/ks/basic/v1/personnel/list`, params);
};
// 人员信息列表 --- 用户
export const perPpersonnelList = (params) => {
  return http.post(`/ks/basic/v1/personnel/list`, params);
};
// 人员执业申请 --- 用户删除
export const perPersonnelDel = (params) => {
  return http.post(`/ks/basic/v1/personnel-del`, params);
};

// 人员执业区域 --- 用户
export const perPracticeArea = (params) => {
  return http.post(`/ks/practice/per/v1/practice-area`, params);
};
// 人员执业申请 --- 用户
export const perPracticeApply = (params) => {
  return http.post(`/ks/practice/per/v1/practice-apply`, params);
};

// 变更记录列表
export const changeRecords = (params) => {
  return http.post(`/ks/draft/v1/change/records`, params);
};
export const changeDelete = (params) => {
  return http.post(`/ks/draft/v1/change/delete`, params);
};
// 变更内容
export const changeDetails = (params) => {
  return http.post(`/ks/draft/v1/change/details`, params);
};
// 字段变更记录
export const changeLog = (params) => {
  return http.post(`/ks/draft/v1/change/pre-value`, params);
};
// 提交按钮
export const changeSubmit = (params) => {
  return http.post(`/ks/draft/v1/change/submit`, params);
};
// 保存按钮
export const changeEdit = (params) => {
  return http.post(`/ks/draft/v1/change/edit`, params);
};
// 文件变更记录
export const changeFileLog = (params) => {
  return http.post(`/ks/draft/v1/change/pre-file`, params);
};
// 文件保存
export const changeFilesSave = (params) => {
  return http.post(`/ks/draft/v1/change/file-save`, params);
};
// 文件删除
export const changeFilesDel = (params) => {
  return http.post(`/ks/draft/v1/change/file-delete`, params);
};
// 人员信息 列表的编辑
export const changeSubEdit = (params) => {
  return http.post(`/ks/draft/v1/change/sub-edit`, params);
};
// 人员信息 列表的删除
export const changeSubDel = (params) => {
  return http.post(`/ks/draft/v1/change/sub-del`, params);
};
// 查询用户手机号
export const sensitivePhoneNum = (params) => {
  return http.post(`/ks/common/sensitive/phone-num`, params);
};